const COLS = [
  {
    title: "海角网",
    links: ["关于我们", "编辑团队", "读者推荐", "联系编辑部"],
  },
  {
    title: "热门栏目",
    links: ["天涯热帖", "论坛爆料", "神贴仓库", "栏目导览"],
  },
  {
    title: "指南",
    links: ["常见问题", "吃瓜守则", "投稿流程", "版权说明"],
  },
];

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-300 bg-background-200">
      <div className="mx-auto max-w-7xl px-4 pb-8 pt-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-window-2-line text-lg" />
              </span>
              <span className="masthead-wordmark text-xl font-black text-foreground-950">海角网</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              一处天涯热帖、论坛爆料与神贴搬运的轻杂志站。汇聚天涯海角各路瓜，点开即达讨论现场，不错过任何论坛风云。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-wechat-line", "ri-weibo-line", "ri-telegram-line", "ri-rss-line"].map((ic) => (
                <a
                  key={ic}
                  href="#top"
                  aria-label={ic}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-foreground-950/10 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${ic} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {COLS.map((c) => (
            <div key={c.title} className="md:col-span-2">
              <h4 className="text-sm font-black text-foreground-950">{c.title}</h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {c.links.map((l) => (
                  <li key={l}>
                    <a href="#top" className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-600">
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-600">© 2026 海角网 · 天涯海角各路瓜，一站读完</p>
          <p className="text-xs text-foreground-500">
            本站内容均整理自公开论坛讨论，版权归原作者所有；搬运仅为阅读便利，请回原帖支持作者。
          </p>
        </div>
      </div>
    </footer>
  );
}